import "../components/password-recovery.css";
import { Eye, EyeOff, FileText, KeyRound, LoaderCircle, LockKeyhole, Mail, ShieldCheck } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useAuth, type MfaChallenge } from "../lib/auth";
import { Link } from "react-router-dom";

export function LoginPage() {
  const { login, verifyMfa } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [challenge, setChallenge] = useState<MfaChallenge>();
  const [code, setCode] = useState("");

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try { setChallenge(await login(email, password)); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "Connexion impossible."); }
    finally { setBusy(false); }
  };

  const verify = async (event: FormEvent) => {
    event.preventDefault(); setBusy(true); setError("");
    try { await verifyMfa(challenge!.challengeToken, code); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "Code MFA incorrect."); }
    finally { setBusy(false); }
  };

  return (
    <main className="login-page">
      <div className="login-page__backdrop" />
      <section className="login-card" aria-labelledby="login-title">
        <div className="login-logo-stage" aria-hidden="true">
          <span className="login-orbit login-orbit--one" />
          <span className="login-orbit login-orbit--two" />
          <img src="/sanru-logo.jpg" alt="" />
        </div>
        <div className="login-card__heading">
          <span className="login-eyebrow"><ShieldCheck size={15} /> Espace sécurisé SANRU</span>
          <h1 id="login-title">Bienvenue sur SANRU RH</h1>
        </div>
        {challenge ? <form onSubmit={verify} className="login-form mfa-form">
          <div className="mfa-intro"><KeyRound size={22}/><div><strong>Vérification en deux étapes</strong><p>Ce compte a activé la protection facultative par Authenticator. Saisissez son code temporaire.</p></div></div>
          <label><span>Code à six chiffres</span><div className="auth-input"><KeyRound size={19}/><input inputMode="numeric" pattern="[0-9]{6}" maxLength={6} value={code} onChange={(event) => setCode(event.target.value.replace(/\D/g, ""))} placeholder="000000" autoComplete="one-time-code" required autoFocus /></div></label>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button className="login-submit" type="submit" disabled={busy || code.length !== 6}>{busy ? <LoaderCircle className="spin" size={19}/> : <ShieldCheck size={18}/>} Vérifier et accéder</button>
          <button className="text-button" type="button" onClick={() => { setChallenge(undefined); setCode(""); setError(""); }}>Revenir à la connexion</button>
        </form> : <form onSubmit={submit} className="login-form">
          <label><span>Adresse e-mail</span><div className="auth-input"><Mail size={19} /><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="nom@sanru.org" autoComplete="username" required autoFocus /></div></label>
          <label><span>Mot de passe</span><div className="auth-input"><LockKeyhole size={19} /><input type={visible ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Votre mot de passe" autoComplete="current-password" required /><button type="button" onClick={() => setVisible((value) => !value)} aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}>{visible ? <EyeOff size={18} /> : <Eye size={18} />}</button></div></label>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button className="login-submit" type="submit" disabled={busy}>{busy ? <LoaderCircle className="spin" size={19} /> : <LockKeyhole size={18} />} {busy ? "Vérification…" : "Se connecter"}</button>
          <Link className="recovery-login-link" to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
          <Link className="candidate-access" to="/carriere"><FileText size={18}/><span><strong>Vous êtes candidat ?</strong><small>Voir les offres et déposer votre CV sans compte</small></span></Link>
        </form>}
        <footer><span><i /> Serveur local SANRU</span><small>Accès réservé au personnel autorisé</small></footer>
      </section>
    </main>
  );
}
